module.exports = __webpack_public_path__ + "static/media/linkExternal.0961793f.svg";